const isErrorBlacklisted = (middlewareConfig, actionType, error) => {
  const {
    blacklists = {}
  } = middlewareConfig;
  const blacklist = blacklists[actionType];
  if (!blacklist) {
    return false;
  }
  if (blacklist.statusCodes && blacklist.statusCodes.includes(error.status)) {
    return true;
  }
  return false;
};
export default ((config = {}) => () => next => action => {
  if (action.error && !isErrorBlacklisted(config, action.type, action.error)) {
    const {
      error,
      type
    } = action;
    const extra = {};
    try {
      // add request info
      if (error.options && error.options.data) {
        extra.requestParams = JSON.parse(error.options.data);
      }

      // add response info
      if (error.responseJSON) {
        extra.response = error.responseJSON;
      } else if (error.data) {
        extra.response = JSON.parse(error.data);
      }
    } catch (exc) {
      // nothing else we can do here
      extra.jsonParsingException = exc;
    }
    if (!config.ravenInstance) {
      console.error('Raven middleware tried to capture exception but Raven instance not provided in config');
    } else {
      config.ravenInstance.captureException(error, {
        logger: 'redux middleware',
        tags: {
          reportingActionType: type
        },
        fingerprint: [type, error.status],
        extra
      });
    }
  }
  return next(action);
});